"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showKeyboard = exports.KeyboardGuide = void 0;
const react_1 = __importDefault(require("react"));
const keyAndEffects = [
    {
        key: "Ctrl+Enter",
        effect: "翻訳候補を表示します",
    },
    {
        key: "Tab",
        effect: "翻訳候補を確定します。カーソル位置まで、または1単語の翻訳が確定します。",
    },
    {
        key: "Esc",
        effect: "翻訳候補を破棄します。",
    },
    {
        key: "↓",
        effect: "次の行にカーソルを移動します（この操作の後でTabキーを押すことで、翻訳候補をまとめて確定できます）",
    },
    {
        key: "Ctrl + End (Windows/Linux) / Command + ↓ (Mac)",
        effect: "カーソルを末尾に移動します（この操作の後でTabキーを押すことで、翻訳候補をすべて確定できます）",
    },
    {
        key: "Ctrl + → (Windows) / Command + → (Mac)",
        effect: "翻訳を保存し (可能なら) 、翻訳ステータスを次に進行後 (未設定 → 翻訳済み → 校閲済み)、次の翻訳テキストを選択します",
    },
    {
        key: "Ctrl + ↓ (Windows) / Command + ↓ (Mac)",
        effect: "翻訳を保存せず、次の翻訳テキストを選択します",
    },
    {
        key: "Ctrl + ↑ (Windows) / Command + ↑ (Mac)",
        effect: "翻訳を保存せず、前の翻訳テキストを選択します",
    },
];
const KeyboardGuide = () => {
    return (react_1.default.createElement("table", null,
        react_1.default.createElement("tbody", null, keyAndEffects.map(({ key, effect }) => (react_1.default.createElement("tr", { key: key },
            react_1.default.createElement("td", { style: {
                    padding: "10px",
                    fontWeight: "bold",
                } }, key),
            react_1.default.createElement("td", { style: { padding: "10px" } }, effect)))))));
};
exports.KeyboardGuide = KeyboardGuide;
const showKeyboard = (modalFormFullScreen) => __awaiter(void 0, void 0, void 0, function* () {
    yield modalFormFullScreen({
        title: "キー操作一覧",
        children: (react_1.default.createElement("div", null,
            react_1.default.createElement(exports.KeyboardGuide, null))),
    });
});
exports.showKeyboard = showKeyboard;
